import React, {Fragment} from 'react';
import Navbar from '../../components/Navbar'
import PageTitle from '../../components/pagetitle'
import ServiceForAbout from '../../components/ServiceForAbout'
import SupportAbout from '../../components/SupportAbout'
import Footer from '../../components/footer'
import Scrollbar from '../../components/scrollbar'
import { Helmet } from 'react-helmet';
import aboutBanner from '../../images/banners/about.webp'
import Pilars from '../../components/Pilars';

const AboutPage =() => {
    return(
        <Fragment>
            <Helmet>
                <title>About | Dar-ul-Quran Academy UK</title>
                <meta name="description" content="Learn about Dar-ul-Quran Academy, our mission, vision, and commitment to providing quality online Quran education for UK families." />
                <link rel="canonical" href="https://www.thedarulquran.com/about" />
            </Helmet>
            <Navbar/>
            <PageTitle pageTitle={'About Us'} pagesub={'About'} backgroundImage={aboutBanner} hideText={true}/> 
            <ServiceForAbout/>
            <Pilars/>
            <SupportAbout/>
            <Footer footerClass={'wpo-ne-footer-2'}/>
            <Scrollbar/>
        </Fragment>
    )
};

export default AboutPage;
